/* @flow */

import React from 'react';
import styled from 'styled-components';

import withI18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import FlexBox from '../../FlexBox';

const WrapperBox = styled(FlexBox)`
  width: 100%;
  background: #0f1217;
`;

const Content = styled(FlexBox)`
  width: 100%;
  max-width: 1260px;
  margin: 0 auto;
  font-family: ${({ theme }) => theme.fontIBMLight};
  padding: 90px 0;
`;

const Item = styled.div`
  width: 33.33%;
  ${({ hasMarginTop }) => (hasMarginTop ? 'margin-top: 90px;' : null)};
  > img {
    display: inline-block;
    margin-right: 30px;
    width: 54px;
    float: left;
  }
  > div {
    display: inline-block;
    padding-top: 6px;
    > p {
      color: #fff;
      font-size: 14px;
      margin: 0;
      font-family: ${({ theme }) => theme.fontIBMMedium};
    }
    > a {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.6);
      text-decoration: none;
    }
  }
`;

type Props = {
  i18n: Object,
  locale: string,
};

export default
@withI18n
class EmailList extends React.Component<Props> {
  static defaultProps = {
    i18n: {},
    locale: 'en',
  };

  render() {
    const { i18n } = this.props;
    return (
      <WrapperBox direction="column" id="email">
        <Content justify="space-between">
          <Item>
            <img src={require('./imgs/Apply-to-listing.svg')} alt="Apply to List" />
            <div>
              <p>{getLabel('exchange-emailList-applyToList', i18n)}</p>
              <a id="emailList-a-applyToList" href="mailto:Listing@binance.com">Listing@binance.com</a>
            </div>
          </Item>
          <Item>
            <img src={require('./imgs/Product-feedback.svg')} alt="Product Feedback" />
            <div>
              <p>{getLabel('exchange-emailList-productFeedback', i18n)}</p>
              <a id="emailList-a-productFeedback" href="mailto:Product@binance.com">Product@binance.com</a>
            </div>
          </Item>
          <Item>
            <img src={require('./imgs/Marketing-and-PR.svg')} alt="PR and Marketing" />
            <div>
              <p>{getLabel('exchange-emailList-PRMarketing', i18n)}</p>
              <a id="emailList-a-PRMarketing" href="mailto:PR@binance.com">PR@binance.com</a>
              <br />
              <a id="emailList-a-PRMarketing-1" href="mailto:Market@binance.com">Market@binance.com</a>
            </div>
          </Item>
          {
            /*
          <Item>
          <img src={require('./imgs/Customer-service.svg')} alt="Customer service" />
          <div>
            <p>{getLabel('exchange-emailList-customerService', i18n)}</p>
            <a
              href="https://binance.zendesk.com"
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              {getLabel('exchange-emailList-supportPage', i18n)}
            </a>
          </div>
        </Item>
        */
          }
          <Item hasMarginTop={true}>
            <img src={require('./imgs/BusinessDevelopment.svg')} alt="PR and Marketing" />
            <div>
              <p>{getLabel('exchange-career-businessDevelopment', i18n)}</p>
              <a id="emailList-a-businessDevelopment" href="mailto:Business@binance.com">Business@binance.com</a>
            </div>
          </Item>
          <Item hasMarginTop={true}>
            <img src={require('./imgs/OTC.svg')} alt="OTC" />
            <div>
              <p>{getLabel('exchange-emailList-OTC', i18n)}</p>
              <a id="emailList-a-OTC" href="mailto:Tradedesk1@binance.com">Tradedesk1@binance.com</a>
            </div>
          </Item>
          <Item hasMarginTop={true}>
            <img src={require('./imgs/BNBadoption.svg')} alt="svgbusiness" />
            <div>
              <p>{getLabel('exchange-emailList-UseBnb', i18n)}</p>
              <a id="emailList-a-UseBnb" href="mailto:Usebnb@binance.com">Usebnb@binance.com</a>
            </div>
          </Item>

        </Content>
      </WrapperBox>
    );
  }
}
